import { render, staticRenderFns } from "./JordanWaiver.vue?vue&type=template&id=6992f6ff&scoped=true&"
import script from "./JordanWaiver.vue?vue&type=script&lang=js&"
export * from "./JordanWaiver.vue?vue&type=script&lang=js&"
import style0 from "./JordanWaiver.vue?vue&type=style&index=0&id=6992f6ff&prod&lang=css&"
import style1 from "./JordanWaiver.vue?vue&type=style&index=1&id=6992f6ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992f6ff",
  null
  
)

export default component.exports